import React from 'react';
import { PlatformOption } from '../../service/lobby';
import { GenericFilterDrawer } from './GenericFilterDrawer';

export const FILTER_ALL = 'ALL';
export const FILTER_MARBLES = 'MARBLES';
export const FILTER_BINGO = 'BINGO';
export const FILTER_RDR = 'RACE DAY';
export const FILTER_LEVIATHAN = 'LEVIATHAN';
export const FILTER_ONE_HOUR = 'LIVE 1 HOUR';
export const FILTER_TWO_HOUR = 'LIVE 1 - 2 HOURS';
export const FILTER_OFFLINE = 'OFFLINE NOW';
export const FILTER_TWO_HOUR_PLUS = 'LIVE 2 HOUR +';
export const FILTER_10_PLAYER = 'AUDIENCE <= 10';
export const FILTER_10_100_PLAYER = 'AUDIENCE <= 100';
export const FILTER_100_1000_PLAYER = 'AUDIENCE <= 1000';
export const FILTER_1000_PLAYER = 'AUDIENCE 1000 +';

interface DefaultDrawerProps {
    onClose: () => void;
    resetFilters: () => void;
    applyFilters: () => void;
    isOpen: boolean;
    updateGameTitleFilter: (val: string) => void;
    gameTitleFilter: string;
    updateStreamingPlatformFilter: (val: string) => void;
    streamingPlatformFilter: PlatformOption | typeof FILTER_ALL;
}

export const DefaultFilterDrawer: React.FC<DefaultDrawerProps> = ({
    isOpen,
    applyFilters,
    resetFilters,
    onClose,
    updateGameTitleFilter,
    gameTitleFilter,
    updateStreamingPlatformFilter,
    streamingPlatformFilter,
}) => (
    <GenericFilterDrawer
        filterAll={FILTER_ALL}
        onClose={onClose}
        isOpen={isOpen}
        resetFilters={resetFilters}
        applyFilters={applyFilters}
        sections={[
            {
                otherOptions: [FILTER_MARBLES, FILTER_BINGO, FILTER_LEVIATHAN, FILTER_RDR],
                updateFunc: updateGameTitleFilter,
                currentValueStateValue: gameTitleFilter,
                name: 'Sixes',
                groupName: 'gameFilterGroup',
                groupCssClass: 'game-filters',
            },
            {
                otherOptions: [PlatformOption.Twitch],
                updateFunc: updateStreamingPlatformFilter,
                currentValueStateValue: streamingPlatformFilter,
                name: 'Streaming Platform',
                groupName: 'streamingPlatformFilterGroup',
                groupCssClass: 'streaming-platform-filters',
            },
        ]}
    />
);
